<template>
  <!-- 导航开始 -->
  <div class='commonClientinfo' :class="{appBool:appBool}">
    <div class="topBox" v-if="!isSearchLoading && !isDelBox && isRbac!==3">
      <div class="infoBox">
        <div class="aa">
          <div @click="viewHeadpathFun" class="letBox" :class="{photo:info.photo}" :style="{'backgroundImage':'url('+info.photo+')'}">
            <span v-if="!info.photo">{{info.user?info.user.charAt(0):''}}</span>
          </div>
          <div class="ritBox">
            <ul>
              <li>
                {{info.user?info.user:'未知'}} · {{info.business_id_title}}{{info.city_name?' · '+info.city_name:''}} ·
                <span v-if="info.type==='1'">机会</span>
                <span v-if="info.type==='2'">意向</span>
                <span v-if="info.type==='3'">签约</span>
              </li>
              <li>
                <span v-if="info.is_protect==='1'" class="badge badge-success badge-pill">长期客户</span>
                <span v-if="info.new_data==='1'" class="badge badge-danger text-white badge-pill">24H</span>
                <span v-if="info.is_del==='1'" class="badge badge-danger text-white badge-pill">回收站</span>
                <span v-if="info.type!=='1' && info.is_del!=='1'" @click="qiehuanZhuangtai('ui-client-info-savezhuangtai')" class="cursor badge badge-light badge-pill">{{info.duty_status_title?info.duty_status_title:'状态-空'}}▷</span>
                <span v-else class="badge badge-light badge-pill">{{info.duty_status_title?info.duty_status_title:'状态-空'}}</span>
                <span v-if="info.type!=='1' && info.is_del!=='1'" @click="qiehuanZhuangtai('ui-client-info-savezhuangtai')" class="cursor badge badge-light badge-pill">{{info.duty_level_title?info.duty_level_title:'级别-空'}}▷</span>
                <span v-else class="badge badge-light badge-pill">{{info.duty_level_title?info.duty_level_title:'状态-空'}}</span>
                <span v-if="info.type!=='1' && info.is_del!=='1'" @click="qiehuanZhuangtai('ui-client-info-savezhuangtai')" class="cursor badge badge-light badge-pill">{{info.source_id_title?info.source_id_title:'来源-空'}}▷</span>
                <span v-else class="badge badge-light badge-pill">{{info.source_id_title?info.source_id_title:'状态-空'}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="cc dd">
          <span v-if="info.duty_uid_user">负责人：<i>{{info.duty_uid_user}} · {{info.duty_time_str}}</i></span>
          <span>创建人：<i>{{info.adduid_user}} · {{info.addtime_str}}</i></span>
        </div>
        <div class="cc">
          <span>项&nbsp;&nbsp;&nbsp;目：<i>{{
              [info.selftages_str,info.is_items_str,info.is_visa_str,info.is_country_str].filter(v=>{return v && v.trim()})
                .join(',')}}{{(!info.selftages_st&&!info.is_items_str&&!info.is_visa_str&&!info.is_country_str)?'未设置...':''}}</i></span>
          <span>共享人：<i>{{shareStr?shareStr:'未共享...'}}</i></span>
        </div>
        <div class="bb">
          <span>备&nbsp;&nbsp;&nbsp;注：<i>{{info.content?info.content:'未设置...'}}</i></span>
        </div>
      </div>
      <div class="menuBox">
        <span @click="qiehuanFun('ui-client-info-trace')" :class="{active:isCompnentElement==='ui-client-info-trace'}">维护</span>
        <span @click="qiehuanFun('ui-client-info-show')" :class="{active:isCompnentElement==='ui-client-info-show'}">信息</span>
        <span v-if="info.type!=='1' && info.is_del!=='1'" @click="qiehuanFun('ui-client-info-contact')" :class="{active:isCompnentElement==='ui-client-info-contact'}">成员</span>
        <span v-if="info.type!=='1' && info.is_del!=='1'" @click="qiehuanFun('ui-client-info-memo')" :class="{active:isCompnentElement==='ui-client-info-memo'}">备忘</span>
        <span v-if="info.type==='3' && info.is_del!=='1'" @click="qiehuanFun('ui-client-info-contract')" :class="{active:isCompnentElement==='ui-client-info-contract'}">合同</span>
        <span v-if="info.type!=='1' && info.is_del!=='1'" @click="qiehuanFun('ui-client-info-attachment')" :class="{active:isCompnentElement==='ui-client-info-attachment'}">附件</span>
        <span v-if="isRbac===1 || isRbac===2 || info.is_del==='1'" @click="qiehuanFun('ui-client-info-share')" :class="{active:isCompnentElement==='ui-client-info-share'}">
          <i class="iconfont icon-cog"></i>
        </span>
      </div>
    </div>
    <div class="mainBox" v-if="!isSearchLoading && !isDelBox && isRbac!==3">
      <component :qiehuanZhuangtai="qiehuanZhuangtai" :isDelFun="isDelFun" :rootUnitIsSuccessFun="rootUnitIsSuccessFun" :token="token" :info="info" :pInitDataInfo="initDataInfo" :is="isCompnentElement" :isRbac="isRbac"></component>
    </div>
    <div class="searchLoadingBox" v-if="isSearchLoading && isRbac!==3">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
    <div class="noRbacBox" v-if="isRbac===3">
      <i class="iconfont icon-permissions-user"></i>
      <p>暂无权限</p>
      <span v-if="isDel==='1'">需回收站查看权限</span>
      <span v-if="isDel!=='1' && isType==='1'">需机会公海查看权限</span>
      <span v-if="isDel!=='1' && isType==='2'">负责的意向,同事的意向,共享的意向,意向数据库权限可查看</span>
      <span v-if="isDel!=='1' && isType==='3'">负责的签约,同事的签约,共享的签约,签约数据库权限可查看</span>
    </div>
    <div class="successBox text-success" v-if="isDelBox">
      <i class="iconfont icon-duigouxiao"></i>
      <div>
        删除成功
      </div>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import uiClientInfoSavezhuangtai from '@/components/common/clientinfo/savezhuangtai';
import uiClientInfoTrace from '@/components/common/clientinfo/trace';
import uiClientInfoShow from '@/components/common/clientinfo/show';
import uiClientInfoContact from '@/components/common/clientinfo/contact';
import uiClientInfoMemo from '@/components/common/clientinfo/memo';
import uiClientInfoContract from '@/components/common/clientinfo/contract';
import uiClientInfoAttachment from '@/components/common/clientinfo/attachment';
import uiClientInfoShare from '@/components/common/clientinfo/share';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'Clientinfo',
  props: {
    token: {
      type: String,
      default: '',
    },
    appBool: {
      type: Boolean,
      default: false,
    },
    rootUnitIsSuccessFun: {
      type: Function,
      default() {
        return Function;
      },
    },
  },
  data() {
    return {
      isCompnentElement: 'ui-client-info-trace',
      info: {},
      isSearchLoading: true,
      isDelBox: false,
      // 1完全权限，2共享权限，3无权限
      isRbac: 1,
    };
  },
  computed: {
    shareStr() {
      if (this.info.duty_users_str) {
        return (this.info.duty_users_str.split(',').filter(app => app !== this.info.duty_uid_user)).join(',');
      }
      return '';
    },
  },
  methods: {
    // 切换
    qiehuanZhuangtai(str) {
      console.log(str);
      this.isCompnentElement = str;
    },
    viewHeadpathFun() {
      if (this.info.photo) {
        EventBus.$emit('globalRightBoxFun', { bool: true, compnent: 'ui-client-info-headpath', token: { headpath: this.info.photo, user: this.info.user } });
      }
    },
    isDelFun() {
      this.isDelBox = true;
    },
    qiehuanFun(str) {
      if (this.isCompnentElement !== str) {
        this.isCompnentElement = str;
      }
    },
    initDataInfo() {
      return resultCommons.apiCrmInfo(this, { token: this.token }).then((ob) => {
        if (ob.state === 200) {
          this.info = ob.data;
          this.isSearchLoading = false;
          // 有权限
          this.isRbac = this.info.isRbac;
        } else if (ob.state === 203) {
          // 无权限
          this.isRbac = 3;
          this.isDel = ob.data.is_del;
          this.isType = ob.data.type;
          console.log(ob);
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
        } else {
          this.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
        }
      });
    },
  },
  components: {
    'ui-client-info-trace': uiClientInfoTrace,
    'ui-client-info-show': uiClientInfoShow,
    'ui-client-info-contact': uiClientInfoContact,
    'ui-client-info-memo': uiClientInfoMemo,
    'ui-client-info-contract': uiClientInfoContract,
    'ui-client-info-attachment': uiClientInfoAttachment,
    'ui-client-info-share': uiClientInfoShare,
    'ui-client-info-savezhuangtai': uiClientInfoSavezhuangtai,
  },
  created() {
    this.initDataInfo();
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfo{
  box-shadow: 0 0 1rem rgba(0, 0, 0, .5);
  background: #F6F6F6;
  width: 580px;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  border-radius: 1rem;
  overflow: hidden;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  position: relative;
  &.appBool{
    height: 100%;
    margin: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  div.noRbacBox{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i{
      font-size: 60px;
    }
    p{
      margin-top: 50px;
    }
    span{
      color: #999999;
    }
  }
  div.successBox{
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    i{
      font-size: 60px;
    }
    div{
      margin-top: 45px;
      //width: 100%;
    }
  }
  .topBox{
    background-image: linear-gradient(180deg, #D4DFFA 20%,#EEEFF6 80%);
    background: #2A37FE;
    color: #FFFFFF;
  }
  .infoBox{
    padding: 15px;
    padding-bottom: 10px;
    div.aa{
      display: flex;
      flex-direction: row;
      div.letBox{
        width: 65px;
        height: 65px;
        background: #FFFFFF;
        margin-right: 20px;
        color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'gilroy-semibold';
        font-size: 23px;
        border-radius: 1rem;
        border:2px solid rgba(0,0,0,0.15);
        background-size: 110% auto;
        background-position: center center;
        &.photo{
          border:2px solid rgba(255,255,255,1);
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
          cursor: pointer;
          span{
            display: none;
          }
        }
        //box-shadow: 0 0px 1rem rgba(0, 0, 0, 0.15);
      }
      div.ritBox{
        flex: 1;
        display: flex;
        align-items: center;
        ul{
          flex: 1;
          li{
            &:first-child{
              font-size: 18px;
              margin-bottom: 10px;
            }
            .badge{
              margin-right: 0;
              font-size: 12px;
              font-weight: 300;
              margin-left: 0;
              &:last-child{
                margin: 0;
              }
            }
            &.tow{
              span{
                display: inline-block;
                i{
                  color: #999999;
                  font-style: normal;
                }
              }
            }
          }
        }
      }
    }
    div.dd{
      border-top:1px solid rgba(0,0,0,0.08);
      margin-top: 10px;
    }
    div.cc{
      display: flex;
      padding-top: 10px;
      span{
        display: inline-block;
        flex: 1;
        color: rgba(255,255,255,0.5);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        &:first-child{
          margin-right: 15px;
        }
        i{
          font-style: normal;
          color: #FFFFFF;
        }
      }
    }
    div.bb{
      margin-top: 3px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      span{
        flex: 1;
        color: rgba(255,255,255,0.5);
        i{
          font-style: normal;
          color: #FFFFFF;
        }
      }
    }
  }
  .menuBox{
    display: flex;
    padding-left: 15px;
    padding-right: 15px;
    //color: #FFFFFF;
    span{
      flex: 1;
      display: inline-block;
      text-align: center;
      margin-right: 5px;
      color: rgba(255,255,255,0.5);
      cursor:pointer;
      //border-bottom: 2px solid rgba(0,0,0,0);
      letter-spacing: 3px;
      line-height: 1.8em;
      &.active{
        //border-bottom: 2px solid rgba(255,255,255,0.8);
        color: #FFFFFF;
        background: rgba(0,0,0,0.2);
        border-top-right-radius: 0.3rem;
        border-top-left-radius: 0.3rem;
      }
      &:last-child{
        margin: 0;
      }
      &:hover{
        //border-bottom: 2px solid rgba(255,255,255,0.8);
        background: rgba(0,0,0,0.2);
        border-top-right-radius: 0.3rem;
        border-top-left-radius: 0.3rem;
        //color: #333333;
      }
    }
  }
  .mainBox{
    flex: 1;
    display: flex;
    overflow:hidden;
    position: relative;
  }
}
@media (max-width: 1200px) {
  .commonClientinfo {
    width: 550px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/index.vue